import StoreAction from "../../../../constants/store-action";
const createEmploymentField = (store) => {
    const value = store.data.householdEconomy.employment;
    const update = (newValue) => store.dispatchStoreAction(StoreAction.UPDATE_NAMED_VALUE, {
        type: "householdEconomy",
        name: "employment",
        value: newValue,
    });
    const field = {
        value,
        onChange: update,
    };
    return field;
};
export default createEmploymentField;
